module.exports = __webpack_public_path__ + "img/los-cocos-room-header-2-x.92d865cf.png";